import {
  assertRequestAuthority,
  captureRequestAuthority,
  requestAuthorityHeader,
} from "./authority";
import { CyraError } from "./errors";
import { createIdempotencyKey } from "./idempotency";
import { readSessionCredentials } from "./session-credentials";

export interface SessionHeaders {
  authorization: string;
  "x-cyra-interaction-id"?: string;
  "x-cyra-installation-reference": string;
  "x-cyra-session-id": string;
  "x-cyra-client-authority": string;
}

export interface MutationHeaders extends SessionHeaders {
  "idempotency-key": string;
}

export function createInteractionId(): string {
  return crypto.randomUUID();
}

export async function sessionHeaders(
  interactionId = createInteractionId(),
): Promise<SessionHeaders> {
  const authority = captureRequestAuthority();
  const credentials = await readSessionCredentials();
  assertRequestAuthority(authority, credentials?.sessionId ?? null);
  if (!credentials) {
    throw new CyraError({
      code: "SESSION_REQUIRED",
      message: "A valid Firebase identity and Cyra session are required.",
      requestId: "client",
    });
  }
  return {
    authorization: `Bearer ${credentials.firebaseToken}`,
    "x-cyra-interaction-id": interactionId,
    "x-cyra-installation-reference": credentials.installationReference,
    "x-cyra-session-id": credentials.sessionId,
    [requestAuthorityHeader]: String(authority.revision),
  };
}

export async function mutationHeaders(
  idempotencyKey = createIdempotencyKey(),
): Promise<MutationHeaders> {
  return { ...(await sessionHeaders()), "idempotency-key": idempotencyKey };
}
